import { AccountTypeDefinition } from '../utils/urlResolver';
import axios from '.';

export const getAccountTypeDefinitions = (params) => {
  return axios({
    method: 'GET',
    url: AccountTypeDefinition.listing,
    params,
  });
};

export const addAccountTypeDefinitions = (data) => {
  return axios({
    method: 'POST',
    url: AccountTypeDefinition.add,
    data,
  });
};

export const editAccountTypeDefinitions = (data) => {
  return axios({
    method: 'PUT',
    url: AccountTypeDefinition.edit,
    data,
  });
};
